import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';


@Component({
    selector: 'expired-assignments-dialog',
    templateUrl: 'expired-assignments-dialog.html',
  })
  export class ExpiredAssignmentsDialog {
  @Input() showMe: boolean = false;
  @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(){}

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(true);
  }
}
